import { IllegalArgumentError } from "@archipad-js/core/error";
import { BugNoteEntity } from "./BugNoteEntity";
import { BugNoteAnnotationGeneratedEntity } from "./generated/BugNoteAnnotationGeneratedEntity";

export abstract class BugNoteAnnotationEntity extends BugNoteAnnotationGeneratedEntity {
    public get parentAnnotatedEntity(): BugNoteEntity {
        return this.bugNote;
    }

    public set parentAnnotatedEntity(parentAnnotatedEntity: BugNoteEntity) {
        if (!parentAnnotatedEntity) {
            throw new IllegalArgumentError("cannot be null nor undefined", "parentAnnotatedEntity");
        }
        this.bugNote = parentAnnotatedEntity;
    }
}
